import { render, staticRenderFns } from "./GuppyConversationListItem.vue?vue&type=template&id=bb79cc0c&"
import script from "./GuppyConversationListItem.vue?vue&type=script&lang=js&"
export * from "./GuppyConversationListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports